import MapContentHolder from './MapContentHolder';

export default MapContentHolder;
